export const columns = [
  // {
  //   title: "序号",
  //   width: 60,
  //   slots: { customRender: "index" },
  // },
  {
    title: "清单编号",
    width: 150,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "清单名称",
    width: 150,
    dataIndex: "name",
    key: "name",
  },
  {
    title: "项目特征",
    width: 200,
    dataIndex: "feature",
    key: "feature",
  },
  {
    title: "结算单位",
    width: 150,
    dataIndex: "unit",
    key: "unit",
  },
  {
    title: "当前合同",
    align: "center",
    children: [
      {
        title: "工程量",
        width: 150,
        align: "right",
        dataIndex: "count",
        key: "count",
      },
      {
        title: "综合单价（￥）",
        width: 150,
        align: "right",
        dataIndex: "price",
        key: "price",
        slots: { customRender: "price" },
      },
      {
        title: "合价（￥）",
        width: 150,
        align: "right",
        dataIndex: "totalPrice",
        key: "totalPrice",
        slots: { customRender: "totalPrice" },
      },
    ],
  },
];
